import { BaseModel } from "modules/core";

export class AddProductFormModel extends BaseModel {
  materialType!: string;

  // Common fields - Enhanced to store both value and text
  styleNo?: string;
  styleNoText?: string;
  category?: string;
  categoryText?: string;
  collectionName?: string;
  collectionNameText?: string;
  kt?: string;
  ktText?: string;
  fromNetWt?: number;
  toNetWt?: number;
  goldRate?: number;
  image?: string;

  // Gold specific fields
  estimateAmt?: number;

  // Diamond specific fields
  odKt?: string;
  odKtText?: string;
  colorCode?: string;
  diamondClarity?: string;
  diamondClarityText?: string;
  diaWt?: number;
  diaQty?: number;
  diaAmt?: number;
  premiumPromo?: string;
  srpMrp?: string;
  srpMrpText?: string;
  colorStoneAmt?: number;
  subMrp?: number;
  cgst?: number;
  igst?: number;
  mrp?: number;
  size?:number
}
